export default __webpack_public_path__ + "static/media/Ravi_Teja_Alchuri_Resume.6d37cc60.pdf";